// @ts-nocheck
import BillingStatusReducer, {
    BillingStatusActions,
} from "@store/Framework/Store/Store/Pages/BillingStatus/BillingStatusReducer";
import { combineReducers } from "redux";

const pagesReducer = combineReducers({
    billingStatus: BillingStatusReducer,
});

export type PagesActions = BillingStatusActions;

export default pagesReducer;
